import { VARIABLES } from '@core/styles/variables';
/**
 * Placeholder for default baked-in theme. Use it to extend you own theme as
 * it loads all available variables in preferred order.
 */
export const theme = {
    key: 'blended',
    variables: VARIABLES.map(([name]) => [name, '']),
};
